declare namespace $ {

	export class $mol_icon_camera_flip extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=flip.view.tree.d.ts.map